"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _InputAdornment2 = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _VisibilityOff2 = _interopRequireDefault(require("@mui/icons-material/VisibilityOff"));
var _Visibility2 = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _formik = require("formik");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var Yup = _interopRequireWildcard(require("yup"));
var _services = require("../../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SignInForm({
  onSignedIn,
  ...props
}) {
  const [passwordShowed, showPassword] = (0, _react.useState)(false);
  const {
    t,
    i18n: {
      language
    }
  } = (0, _reactI18next.useTranslation)();
  const {
    isSubmitting,
    values,
    touched,
    errors,
    setFieldValue,
    handleChange,
    handleSubmit
  } = (0, _formik.useFormik)({
    initialValues: {
      email: '',
      password: '',
      rememberMe: false
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required(t('commons.sign_in_form.email_required') || '')
    }),
    enableReinitialize: true,
    onSubmit
  });
  async function onSubmit({
    email,
    password,
    rememberMe
  }, {
    setSubmitting,
    setErrors
  }) {
    setSubmitting(true);
    try {
      const user = await _services.AuthService.signInWithEmail(email, password, rememberMe, language);
      onSignedIn(user);
    } catch (err) {
      setErrors({
        email: t(typeof err === 'object' && err && 'code' in err && err.code === 429 ? 'commons.sign_in_form.too_many_attempts' : 'commons.sign_in_form.invalid_credentials') || ''
      });
      setFieldValue('password', '', false);
      setSubmitting(false);
    }
  }
  return /*#__PURE__*/_react.default.createElement(StyledForm, _extends({
    onSubmit: handleSubmit
  }, props), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    disabled: isSubmitting,
    error: Boolean(errors.email && touched.email),
    helperText: touched.email && errors.email,
    id: "email",
    label: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.sign_in_form.email"
    }),
    margin: "dense",
    name: "email",
    onChange: handleChange,
    size: "small",
    type: "email",
    value: values.email,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    disabled: isSubmitting,
    id: "password",
    label: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.sign_in_form.password"
    }),
    margin: "dense",
    name: "password",
    onChange: handleChange,
    size: "small",
    slotProps: {
      input: {
        endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
          "aria-label": "toggle password visibility",
          onClick: () => showPassword(!passwordShowed),
          size: "small"
        }, passwordShowed ? /*#__PURE__*/_react.default.createElement(_Visibility2.default, null) : /*#__PURE__*/_react.default.createElement(_VisibilityOff2.default, null)))
      }
    },
    type: passwordShowed ? 'text' : 'password',
    value: values.password,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    component: "fieldset",
    disabled: isSubmitting,
    margin: "dense"
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
      color: "primary",
      name: "rememberMe",
      onChange: handleChange,
      value: values.rememberMe
    }),
    label: /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      variant: "caption"
    }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.sign_in_form.remember_me"
    }))
  })), /*#__PURE__*/_react.default.createElement(StyledButton, {
    color: "primary",
    disabled: isSubmitting,
    size: "medium",
    type: "submit",
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.sign_in"
  })));
}
const StyledForm = _styledComponents.styled.form`
  display: flex;
  flex-direction: column;
`;
const StyledButton = (0, _styledComponents.styled)(_Button2.default)`
  && {
    margin-top: 8px;
  }
`;
var _default = exports.default = SignInForm;